module.exports = __webpack_public_path__ + "static/assets/2535554a9d7cf7e6949d5f4a191548e2.gif";